var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 5.33334V4.00001C10.666 3.64638 10.5255 3.30724 10.2755 3.0572C10.0254 2.80715 9.6863 2.66667 9.33268 2.66667H3.99935C3.64573 2.66667 3.30659 2.80715 3.05654 3.0572C2.80649 3.30724 2.66602 3.64638 2.66602 4.00001V9.33334C2.66602 9.68696 2.80649 10.0261 3.05654 10.2761C3.30659 10.5262 3.64573 10.6667 3.99935 10.6667H5.33268M5.33268 6.66667C5.33268 6.31305 5.47316 5.97391 5.72321 5.72386C5.97326 5.47381 6.31239 5.33334 6.66602 5.33334H11.9993C12.353 5.33334 12.6921 5.47381 12.9422 5.72386C13.1922 5.97391 13.3327 6.31305 13.3327 6.66667V12C13.3327 12.3536 13.1922 12.6928 12.9422 12.9428C12.6921 13.1929 12.353 13.3333 11.9993 13.3333H6.66602C6.31239 13.3333 5.97326 13.1929 5.72321 12.9428C5.47316 12.6928 5.33268 12.3536 5.33268 12V6.66667Z",
    stroke: "#787878",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8d74e933.svg";
export { ForwardRef as ReactComponent };